<template>
  <article class="detailsArticle">
    <!-- ログインしなくても見れる部分 -->
    <header class="detailsArticleHeader">
      <div class="detailsArticleHeaderEyecatch">
        <a :href="fintech.web_site" target="_blank">
          <img :src="fintechThumbnail" alt="" />
        </a>
      </div>
      <template v-if="isInfo">
        <h1 class="pt30">{{ fintech.title }}</h1>
        <h2>{{ fintech.subtitle }}</h2>
      </template>
      <template v-else>
        <h1 class="pt30">{{ fintech.name_en }}</h1>
        <h2>{{ fintech.name_ja }}</h2>
      </template>
      <footer class="detailsArticleFooter">
        <p class="detailsArticleDate">
          <i class="material-icons">access_time</i> {{ dispPublishedAt }}
        </p>
      </footer>
    </header>

    <div class="detailsArticleContents" v-if="!isInfo">
      <h2 class="fintech-headers">企業概要</h2>
      <hr class="spacer" />

      <div class="fintech-wrap">
        <div class="fintech-wrap-items">
          <div class="fintech-icons">
            <img src="/images/fintechs/category.png" class="fintech-icon" />
            カテゴリー
          </div>
          <div
            class="pl20 fintech-data"
            v-html="replaceComma(categoryText)"
          ></div>
        </div>
        <div class="fintech-wrap-items">
          <div class="fintech-icons">
            <img src="/images/fintechs/office.png" class="fintech-icon" />
            本社
          </div>
          <div class="pl20 fintech-data">
            {{ formatOffice(fintech.office_country, fintech.office_city) }}
          </div>
        </div>
        <div class="fintech-wrap-items">
          <div class="fintech-icons">
            <img src="/images/fintechs/service.png" class="fintech-icon" />
            サービス内容
          </div>
          <div
            class="pl20 fintech-data"
            v-html="replaceComma(fintech.services)"
          ></div>
        </div>
        <div class="fintech-wrap-items">
          <div class="fintech-icons">
            <img src="/images/fintechs/published.png" class="fintech-icon" />
            創業
          </div>
          <div class="pl20 fintech-data">{{ establishedAt }}</div>
        </div>
        <div class="fintech-wrap-items">
          <div class="fintech-icons">
            <img src="/images/fintechs/target.png" class="fintech-icon" />
            ターゲット
          </div>
          <div
            class="pl20 fintech-data"
            v-html="replaceComma(fintech.targets)"
          ></div>
        </div>
        <div class="fintech-wrap-items">
          <div class="fintech-icons">
            <img src="/images/fintechs/founder.png" class="fintech-icon" />
            創業者
          </div>
          <div
            class="pl20 fintech-data"
            v-html="replaceComma(fintech.founders)"
          ></div>
        </div>
      </div>
    </div>
    <!-- ログインしなくても見れる部分ここまで -->

    <div class="detailsArticleContents">
      <!-- ログイン後見れる部分 -->
      <div v-show="showBody">
        <template v-if="!isInfo">
          <h2 class="fintech-headers">資金調達</h2>
          <hr class="spacer" />

          <div class="fintech-wrap">
            <div class="fintech-wrap-items">
              <div class="fintech-icons">
                <img
                  src="/images/fintechs/last_procure_at.png"
                  class="fintech-icon"
                />
                最終調達日
              </div>
              <div class="pl20 fintech-data">{{ lastProcuredAt }}</div>
            </div>
            <div class="fintech-wrap-items">
              <div class="fintech-icons">
                <img
                  src="/images/fintechs/total_amount.png"
                  class="fintech-icon"
                />
                総調達額<br />({{ formatDigit(fintech.total_procured_amount) }})
              </div>
              <div class="pl20 fintech-data">
                {{ formatAmount(fintech.total_procured_amount) }}
              </div>
            </div>
            <div class="fintech-wrap-items">
              <div class="fintech-icons">
                <img
                  src="/images/fintechs/last_procure_amount.png"
                  class="fintech-icon"
                />
                最終調達額<br />({{
                  formatDigit(fintech.last_procured_amount)
                }})
              </div>
              <div class="pl20 fintech-data">
                {{ formatAmount(fintech.last_procured_amount) }}
              </div>
            </div>
            <div class="fintech-wrap-items">
              <div class="fintech-icons">
                <img
                  src="/images/fintechs/total_time.png"
                  class="fintech-icon"
                />
                総調達回数
              </div>
              <div class="pl20 fintech-data">
                {{ formatNull(fintech.total_procured_times) }}
              </div>
            </div>
            <div class="fintech-wrap-items">
              <div class="fintech-icons">
                <img src="/images/fintechs/type.png" class="fintech-icon" />
                最終調達タイプ
              </div>
              <div
                class="pl20 fintech-data"
                v-html="replaceComma(fintech.last_procured_type)"
              ></div>
            </div>
            <div class="fintech-wrap-items">
              <div class="fintech-icons">
                <img
                  src="/images/fintechs/investors.png"
                  class="fintech-icon"
                />
                主要投資家
              </div>
              <div
                class="pl20 fintech-data"
                v-html="replaceComma(fintech.main_investors)"
              ></div>
            </div>
          </div>
        </template>

        <h2 class="fintech-data-title mt30" v-if="!isInfo">
          {{ fintech.title }}
        </h2>
        <h3 v-if="!isInfo && hasSubtitle" class="mb10">
          {{ fintech.subtitle }}
        </h3>
        <div class="tiny-textbox" v-html="fintech.body"></div>
      </div>
      <!-- ログイン後見れる部分ここまで -->

      <div class="textbox">
        <tags :tags="fintech.tags" class="detail-tags"></tags>

        <div class="detailsArticleReadmore" v-show="!showBody">
          <!-- 全表示記事 -->
          <template v-if="scopeAll"> </template>

          <!-- スタンダード記事 -->
          <template v-else-if="scopeStandard">
            <a v-if="!loggedIn" href="/login">ログインしてつづきを読む</a>
          </template>

          <!-- プレミアム記事 -->
          <template v-else>
            <template v-if="!loggedIn || !isPremiumUser">
              <div class="detailsArticleReadmorePremium">
                <p class="detailsArticleReadmorePremiumDesc">
                  このつづきはNCB Library
                  プレミアム会員にご登録いただくとお読みいただけます
                </p>
                <a href="/register/plan_select">
                  <p
                    class="detailsArticleReadmorePremiumBtnTextOne"
                    v-if="trialNum == 0"
                  >
                    つづきを読む
                  </p>
                  <p class="detailsArticleReadmorePremiumBtnTextOne" v-else>
                    {{ trialNum }}日間の無料トライアルに登録
                  </p>
                </a>
                <p class="detailsArticleReadmoreLogin">
                  すでにプレミアム会員の方は
                  <a class="detailsArticleReadmoreLoginLink" href="/login"
                    >こちら</a
                  >
                </p>
              </div>
            </template>
          </template>
        </div>
      </div>

      <div class="detailsArticleShare">
        <ul>
          <li>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a href="javascript:void(0);" v-on="on" @click="shareTwitter">
                  <img src="/images/x-logo-black.png" class="sns-icon-small" />
                </a>
              </template>
              <span>Xでポスト</span>
            </v-tooltip>
          </li>
          <li>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a href="javascript:void(0);" v-on="on" @click="shareFacebook">
                  <i class="fab fa-facebook"></i>
                </a>
              </template>
              <span>Facebookでシェア</span>
            </v-tooltip>
          </li>
        </ul>
      </div>
    </div>
  </article>
</template>

<script>
import Tags from "./Tags.vue";
import axios from "axios";
import jsonpAdapter from "axios-jsonp";

export default {
  components: {
    Tags
  },

  props: [
    "fintech",
    "fintechThumbnail",
    "dispPublishedAt",
    "isInfo",
    "categoryText",
    "establishedAt",
    "isPreview",
    "forceOpen",
    "lastProcuredAt",
    "scopeAll",
    "scopeStandard",
    "scopePremium",
    "loggedIn",
    "isPremiumUser",
    "trialNum",
    "shareUrl",
    "hasSubtitle"
  ],

  data() {
    return {
      shareWindow: {
        width: 600,
        height: 300
      },
      showBody: this.forceOpen || this.isPreview,
      isHalf: true
    };
  },

  methods: {
    shareTwitter() {
      const url = "https://twitter.com/share?url=" + this.shareUrl;
      const left = Number((window.screen.width - this.shareWindow.width) / 2);
      const top = Number((window.screen.height - this.shareWindow.height) / 2);

      window.open(
        url,
        "twitter_window",
        "width=" +
          this.shareWindow.width +
          ", height=" +
          this.shareWindow.height +
          ", left=" +
          left +
          ", top=" +
          top +
          ", menubar=no, toolbar=no, scrollbars=yes"
      );
    },

    shareFacebook() {
      const url = "https://www.facebook.com/share.php?u=" + this.shareUrl;
      const left = Number((window.screen.width - this.shareWindow.width) / 2);
      const top = Number((window.screen.height - this.shareWindow.height) / 2);

      window.open(
        url,
        "facebook_window",
        "width=" +
          this.shareWindow.width +
          ", height=" +
          this.shareWindow.height +
          ", left=" +
          left +
          ", top=" +
          top +
          ", menubar=no, toolbar=no, scrollbars=yes"
      );
    },

    replaceComma(str) {
      if (!str) {
        return "不明";
      }

      return str.replaceAll(",", "/<br>");
    },

    formatAmount(int) {
      if (!int) {
        return "不明";
      }

      var str = "";

      if (int < 100000) {
        str = "$" + (Math.round(int / 100) * 10) / 100;
      } else {
        str = "$" + (Math.round(int / 100000) * 10) / 100;
      }

      if (str.indexOf(".") === -1) {
        return str + ".0";
      }

      return str;
    },

    formatDigit(int) {
      if (!int) {
        return "千ドル";
      }

      if (int < 100000) {
        return "千ドル";
      }

      return "百万ドル";
    },

    formatNull(str) {
      if (!str) {
        return "不明";
      }
      return str;
    },

    formatOffice(country, city) {
      if (!country && !city) {
        return "不明";
      }
      return country + "/" + city;
    }
  }
};
</script>

<style lang="scss" scoped>
.half {
  width: 48%;
  display: inline-block;
}

.mlauto {
  margin-left: auto;
}

.detail-tags {
  height: inherit !important;
}

.spacer {
  margin-top: 5px;
  margin-bottom: 30px;
}

.pt30 {
  padding-top: 30px !important;
}

.pl20 {
  padding-left: 20px;
}

.mt30 {
  margin-top: 30px !important;
}

.fintech-wrap {
  display: flex;
  flex-wrap: wrap;
  &-items {
    display: flex;
    width: 50%;
    margin-bottom: 50px;
  }
}

.fintech-icons {
  text-align: center;
  width: 40%;
  min-width: 40%;
  font-size: 1.17em;
  font-weight: bold;
}

.fintech-icon {
  width: 50%;
  display: block;
  margin: 0 auto 10px;
}

.fintech-headers {
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 30px !important;
}

.fintech-data {
  font-size: 1.17em;
  font-weight: bold;
  word-break: break-word;
}

.fintech-data-title {
  font-weight: bold;
}

// small
@media screen and (max-width: 750px) {
  .fintech-wrap {
    &-items {
      width: 50%;
      margin-bottom: 30px;
    }
  }

  .fintech-icons {
    font-size: 10px;
  }

  .fintech-data {
    font-size: 10px;
  }
}

.sns-icon-small {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
</style>
